import {
  APP_STORE_BADGE_URL,
  APP_STORE_URL,
  PLAY_STORE_BADGE_URL,
  PLAY_STORE_URL,
} from '@/shared/config'

export function AppStoreBadges() {
  return (
    <div className="flex flex-row items-center justify-center gap-3">
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Download on the App Store"
      >
        <img src={APP_STORE_BADGE_URL} alt="Download on the App Store" className="h-10 w-auto" />
      </a>
      <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" aria-label="Get it on Google Play">
        <img
          src={PLAY_STORE_BADGE_URL}
          alt="Get it on Google Play"
          className="h-[58px] w-auto"
        />
      </a>
    </div>
  )
}
